import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      x: "2",
      y: "2",
      fill: "#B30B00",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.952 16a.729.729 0 0 1-.44-.148c-.472-.355-.536-.75-.506-1.019.083-.74.997-1.513 2.72-2.302a30.495 30.495 0 0 0 1.72-4.883c-.454-.987-.894-2.267-.573-3.018.113-.263.253-.465.515-.552A2.23 2.23 0 0 1 9.85 4c.229 0 .43.295.572.477.134.17.438.532-.169 3.09.612 1.264 1.48 2.553 2.311 3.435a8.835 8.835 0 0 1 1.526-.163c.711 0 1.142.166 1.318.508.146.282.086.612-.177.98-.253.355-.602.542-1.008.542-.553 0-1.196-.35-1.913-1.038-1.29.27-2.794.75-4.01 1.282-.38.806-.744 1.455-1.083 1.93-.466.653-.867.957-1.265.957m1.21-2.329c-.971.546-1.367.994-1.396 1.247-.004.042-.017.152.196.314.068-.021.463-.201 1.2-1.56m6.194-2.017c.37.284.46.428.703.428.106 0 .41-.004.55-.2a.717.717 0 0 0 .104-.188c-.056-.03-.13-.09-.534-.09-.23 0-.518.01-.823.05m-3.393-2.99A32.381 32.381 0 0 1 8.748 12.1c.95-.369 1.982-.69 2.951-.918a15.551 15.551 0 0 1-1.736-2.518M9.687 4.82c-.044.014-.604.798.044 1.46.43-.96-.024-1.467-.044-1.46"
    }, null, -1)
  ])))
}
export default { render: render }